module.exports = __webpack_public_path__ + "img/detallecurso4.fa54f60c.png";